var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "super-collection__collection" }, [
    _c(
      "div",
      { staticClass: "container super-collection__collection-container" },
      [
        _c("div", { staticClass: "super-collection__collection-header" }, [
          _vm._m(0),
          _c("div", { staticClass: "controls-container u-hidden-tablet-up" }, [
            _c("div", { staticClass: "arrows" }, [
              _c(
                "div",
                {
                  staticClass: "arrow arrow-prev",
                  on: { click: _vm.slidePrev }
                },
                [_c("icon", { attrs: { name: "chevron-left", size: "14px" } })],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "arrow arrow-next",
                  on: { click: _vm.slideNext }
                },
                [
                  _c("icon", { attrs: { name: "chevron-right", size: "14px" } })
                ],
                1
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "super-collection__collection-slider-container" },
          [
            _c(
              "swiper",
              {
                ref: "superCollectionSwiper",
                attrs: {
                  options: _vm.swiperWithScrollbar(
                    "[data-scrollbar='super-collection-progress']"
                  )
                }
              },
              _vm._l(_vm.gridProducts, function(product, index) {
                return _c(
                  "swiperSlide",
                  {
                    key: product.id,
                    staticClass: "super-collection__collection-slide"
                  },
                  [
                    _c(
                      "product-tile",
                      {
                        staticClass: "super-collection__product-tile",
                        attrs: {
                          simple: true,
                          product: _vm.productWithoutVariants(product),
                          showMobileATC: false,
                          truncateTitle: false,
                          fullTileClick: true
                        }
                      },
                      [_vm._v(_vm._s(product.title))]
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        ),
        _c("div", {
          staticClass: "super-collection__progress-bar",
          attrs: { "data-scrollbar": "super-collection-progress" }
        })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "super-collection__collection-header-text" },
      [
        _c("div", { staticClass: "h3 super-collection__collection-title" }, [
          _vm._v("Recommended Products")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }